/* Links and gtag event names for the redesigned home + CONSTRA nav/footer.
   The Solutions dropdown reuses rolesInfo and the footer's Solutions column reuses quickLinks,
   both from static-data, so URLs and gtag names stay shared with the old nav/footer. */

import { quickLinks } from '@/assets/db/static-data'

export const homeClients = [
    { name: "Lodha", image: "lodha.png" },
    { name: "Emaar", image: "emaar.png" },
    { name: "Embassy REIT", image: "embassyReit.png" },
    { name: "Birla Estate", image: "birla.png" },
    { name: "Godrej Properties", image: "godrejproperties.png" },
    { name: "Shapoorji Pallonji", image: "shapoorjiPallonji.png" },
    { name: "L&T", image: "lt.jpg" },
    { name: "Tata Projects", image: "tataProjects.png" },
    { name: "Oberoi Realty", image: "oberoiRealty.png" },
    { name: "Prestige Group", image: "prestigeGroup.png" },
    { name: "Marathon", image: "marathon.png" },
    { name: "Piramal Realty", image: "piramalRealty.png" },
    { name: "Gera", image: "gera.png" },
    { name: "Savills", image: "savills.png" },
    { name: "JLL", image: "jll.png" },
    { name: "Runwal Group", image: "runwalGroup.png" },
    { name: "MAIA Estates", image: "maia.png" },
    { name: "HoABL", image: "HoABL.png" },
    { name: "Shriram Properties", image: "shriramProperties.png" },
    { name: "Experion", image: "experion.png" }
]

export const homeNavLinks = [
    {
        name: "Clients",
        url: "/clients",
        gtag: "website_clients"
    },
    {
        name: "Team",
        url: "/#team"
    },
    {
        name: "Blog",
        url: "/blog"
    },
    {
        name: "Contact",
        url: "/contact-us",
        gtag: "website_contactus"
    }
]

export const homeFooterCols = [
    {
        title: "Solutions",
        links: quickLinks.map(link => ({
            name: link.linkName,
            url: link.url,
            gtag: link.gtag
        }))
    },
    {
        title: "Company",
        links: [
            {
                name: "About Us",
                url: "/about-us",
                gtag: "website_aboutus"
            },
            {
                name: "Clients",
                url: "/clients",
                gtag: "website_clients"
            },
            {
                name: "Contact Us",
                url: "/contact-us",
                gtag: "website_contactus"
            },
            {
                name: "FAQs",
                url: "/faqs",
                gtag: "website_faqs"
            }
        ]
    },
    {
        title: "Legal",
        links: [
            {
                name: "Terms of Use",
                url: "/terms-of-use"
            },
            {
                name: "Privacy Policy",
                url: "/privacy-policy"
            },
            {
                name: "Digital Shramik",
                url: "/digital-shramik",
                gtag: "website_digitalshramik"
            }
        ]
    }
]
